import { render, staticRenderFns } from "./index_bak.vue?vue&type=template&id=a094700a&scoped=true"
import script from "./index_bak.vue?vue&type=script&lang=js"
export * from "./index_bak.vue?vue&type=script&lang=js"
import style0 from "./index_bak.vue?vue&type=style&index=0&id=a094700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a094700a",
  null
  
)

export default component.exports